<template>
  <div class="main-screen">
    <Header/>
    <Body/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "./Header.vue";
import Body from "./Body.vue";
import Footer from "./Footer.vue";

export default {
  name: "main-screen",
  components: {
    Header,
    Body,
    Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Main.vue